import gql from 'graphql-tag';

export const deleteAccountMutation = gql`
  mutation deleteAccount($customerId: String!) {
    deleteAccount(customerId: $customerId)
  }
`;
